module.exports = __webpack_public_path__ + "img/metamask-send.b5f2d1cf.png";